export type FloatingTab = { id: string; text: string; icon: string; path: string };

export const floatingTabPanelId = (id: string) => `tabbar-tab-${id}`;
